import { SearchResultInterface } from 'common/types/search-interfaces'
import { clientImagePlaceholderSrc } from 'common/components//entities/BlogPostsNew/utils'

const DEFAULT_RESULTS_SIZE = 10

const getDate = (number: number = DEFAULT_RESULTS_SIZE) => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth()

  return new Date(year, month, Math.floor(Math.random() * number))
}

export const searchResultsData = (
  total: number = DEFAULT_RESULTS_SIZE,
  imageSrc: string = clientImagePlaceholderSrc,
) =>
  [...Array(total).keys()].reduce(
    (acc, id) => [
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      ...acc,
      {
        id,
        image: {
          id: 134,
          path: imageSrc,
          filename: 'image title',
          name: 'image name',
          thumbnail: null,
        },
        path: '',
        type: 'post',
        name: 'Lorem ipsum dolor sit amet',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        content:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna <mark>aliqua</mark>.',
        publication_date: getDate(total),
      } as SearchResultInterface,
    ],
    [] as SearchResultInterface[],
  )
